import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function fetchClients(requestor) {
  return createReduxPromiseAction(ActionTypes.CLIENTS_FETCH, organisationId =>
    requestor
      .get(`${basePath}/organisation/${organisationId}/client`, {
        withCredentials: true,
      })
      .then(response => {
        return response.data;
      }),
  );
}
